export const rules_et = (
  <>
    <p>
      <strong>Lisaloosi reeglid:</strong>
    </p>
    <ol>
<li>“Püsitellimuse lisaloos” (edaspidi lisaloos) viiakse läbi püsitellimusega vahemikus 07.10-03.11.2024 ostetud arvloterii (so Bingo loto, Eurojackpot, Jokker, Keno, Vikinglotto) piletitel olevate mängukombinatsioonide vahel. </li>
<li>Lisaloosi korraldajaks on AS Eesti Loto (asukoht: Hallivanamehe 4, 11317 Tallinn, registrikood 10281170; edaspidi Eesti Loto).</li>
<li>Lisaloosi läbiviimine on reguleeritud käesolevate reeglitega ja lisaloosi võidu vastuvõtmisega kinnitab mängija nõustumist lisaloosi reeglitega. Lisaloosimistest osavõtu ja võidu kättesaamisega seotud kulutusi mängijatele ei kompenseerita. </li>
<li>Lisaloosimised viiakse läbi järgnevatel kuupäevadel: 14.10, 21.10, 28.10 ja 04.11.</li>
<li>Lisaloosi võidufond on 2000 eurot. Võitude jagunemine on järgmine:
<br />14.10	5 x 100 eurot
<br />21.10	5 x 100 eurot
<br />28.10	5 x 100 eurot
<br />04.11	5 x 100 eurot
</li>
<li>Igal lisaloosimisel osalevad kõik eelneva nädala jooksul püsitellimusega ostetud mängukombinatsioonid. Püsitellimusega pilet ostetakse:  
 <ol style={{listStyleType: "lower-alpha"}}>
 <li>uue püsitellimuse vormistamisel koheselt püsitellimuse vormistamisel, ja edaspidi vastavalt kehtiva püsitellimuse reeglile (vt punkt b.)</li>
 <li>kehtiva püsitellimuse korral toimunud loosimise järgsel ööl kell 2.00. </li>
 </ol></li>
<li>Igal lisaloosimisel loositakse elektroonilist juhuarvugeneraatorit kasutades välja viis lisaloosi võitu. </li>
<li>Lisaloosimised viiakse läbi Eesti Lotos, aadressil Hallivanamehe 4, Tallinn. </li>
<li>Lisaloosis ei saa osaleda Eesti Loto töötajad (v.a lapsehoolduspuhkusel olevad isikud), Eesti Loto nõukogu liikmed ja loosimiste üle järelevalvet teostavad isikud. </li>
<li>Lisaloosis ei saa osaleda nooremad kui 16-aastased isikud.</li>
<li>Lisaloosimise tulemused avaldatakse loosimise päeval Eesti Loto kodulehel aadressil www.eestiloto.ee. Võitnud piletinumbrite kohta saab informatsiooni ka Eesti Loto infotelefonil 650 2030.</li>
<li>Võidud kantakse võitnud mängija mängukonto e-rahakotti 7 päeva jooksul alates loosimisele järgnevast päeva. </li>
<li>Võidu väljamaksmise lõpptähtaeg on 11.11.2024. </li>
<li>Vääramatu jõu (force majeure) ilmnemisel on Eesti Lotol ühepoolne õigus katkestada lisaloos ja jätta võidud välja loosimata ja/või üle andmata, teatades sellest koheselt meedia vahendusel.</li>
<li>Kõik lisaloosiga seotud vaidlused lahendatakse vastavalt Eesti Vabariigis kehtivale seadusandlusele. Kõik pretensioonid seoses lisaloosi korraldamise ja/või läbiviimisega tuleb saata kirjalikult Eesti Loto aadressil (vt p. 2) hiljemalt 14.11.2024. Pretensiooni lahendamise tähtaeg on 2 nädalat arvates pretensiooni laekumisest. Anonüümseid pretensioone ja avaldusi läbi ei vaadata ning neile ei vastata.</li>

      </ol>
  </>
);

export const rules_ru = (
  <>
    <p>
      <strong>Правила дополнительного розыгрыша:
</strong>
    </p>

<ol>


<li>"Дополнительный розыгрыш подписок" (далее дополнительный розыгрыш) проводится среди игровых комбинаций, указанных на билетах числовой лотереи (таких как Bingo loto, Eurojackpot, Jokker, Keno, Vikinglotto), купленных по подписке в период с 07.10 по 03.11.2024.</li>
<li>Учредителем дополнительного розыгрыша является AS Eesti Loto (адрес: Халливанамехе 4, 11317 Таллинн, регистрационный код 10281170; далее Eesti Loto).</li>
<li>Проведение дополнительного розыгрыша регулируется настоящими правилами, и принятием выигрыша игрок подтверждает согласие с правилами дополнительного розыгрыша. Затраты, связанные с участием в розыгрыше и получением выигрыша, игрокам не компенсируются.</li>
<li>Дополнительные розыгрыши проводятся в следующие даты: 14.10, 21.10, 28.10 и 04.11.</li>
<li>Призовой фонд дополнительного розыгрыша составляет 2000 евро. Структура выигрышей:
<br />14.10	5 × 100 евро 
<br />21.10 5 × 100 евро 
<br />28.10 5 × 100 евро 
<br />04.11 5 × 100 евро</li>
<li>
В каждом дополнительном розыгрыше участвуют все игровые комбинации, купленные по подписке в течение предыдущей недели. 
<br />Билет по подписке покупается: 
<ol style={{listStyleType: "lower-alpha"}}>
<li>при оформлении новой подписки сразу после её оформления, а в дальнейшем согласно действующему правилу подписки (см. пункт b.) </li>
<li>при действующей подписке билет покупается ночью в 2:00 после проведённого розыгрыша.</li>
</ol>
</li>
<li>В каждом дополнительном розыгрыше с использованием генератора случайных чисел разыгрываются пять выигрышей.</li>
<li>Дополнительные розыгрыши проводятся в офисе Eesti Loto по адресу: Hallivanamehe 4, Таллинн.</li>
<li>В дополнительном розыгрыше не могут участвовать сотрудники Eesti Loto (за исключением лиц, находящихся в декретном отпуске), члены правления Eesti Loto и лица, осуществляющие надзор за розыгрышами.</li>
<li>В дополнительном розыгрыше не могут участвовать лица младше 16 лет.</li>
<li>Результаты дополнительного розыгрыша публикуются в день розыгрыша на сайте Eesti Loto по адресу www.eestiloto.ee. Информацию о выигравших билетах также можно получить по телефону службы поддержки Eesti Loto 650 2030.</li>
<li>Выигрыши перечисляются в э-кошелёк игрового аккаунта победителя в течение 7 дней со дня, последующего за днём розыгрыша.</li>
<li>Окончательный срок выплаты выигрышей — 11.11.2024.</li>
<li>В случае возникновения форс-мажора Eesti Loto имеет одностороннее право прервать дополнительный розыгрыш и отказаться от проведения розыгрыша и/или выдачи выигрышей, уведомив об этом через средства массовой информации.</li>
<li>Все споры, связанные с дополнительным розыгрышем, решаются в соответствии с действующим законодательством Эстонской Республики. Все претензии, касающиеся организации и/или проведения дополнительного розыгрыша, должны быть направлены в письменном виде по адресу Eesti Loto (см. пункт 2) не позднее 14.11.2024. Срок рассмотрения претензий составляет 2 недели с момента их получения. Анонимные претензии и заявления не рассматриваются и на них не отвечают.</li>




</ol>
  </>
);
